"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
var react_1 = require("@fluentui/react");
var react_i18next_1 = require("react-i18next");
var react_2 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var forms_1 = require("../forms");
require("./FilteredHeaderColumn.scss");
var FilterType;
(function (FilterType) {
    FilterType[FilterType["Label"] = 0] = "Label";
    FilterType[FilterType["Text"] = 1] = "Text";
    FilterType[FilterType["Date"] = 2] = "Date";
    FilterType[FilterType["Enum"] = 3] = "Enum";
    FilterType[FilterType["Custom"] = 4] = "Custom";
})(FilterType = exports.FilterType || (exports.FilterType = {}));
function init(fieldLength) {
    return {
        fieldLength: fieldLength,
        calloutOpen: false,
        isFiltered: false,
        textValues: Array(fieldLength),
        dateValues: Array(fieldLength),
        itemValues: Array(fieldLength),
        commitedTextValues: Array(fieldLength),
        commitedDateValues: Array(fieldLength),
        commitedItemValues: Array(fieldLength),
    };
}
function updateStateTextValues(state, fieldValue, fieldIndex) {
    return __assign(__assign({}, state), { textValues: __spreadArrays(state.textValues).map(function (v, i) {
            if (fieldIndex === i) {
                return fieldValue;
            }
            return v;
        }) });
}
function updateStateDateValues(state, fieldValue, fieldIndex) {
    return __assign(__assign({}, state), { dateValues: __spreadArrays(state.dateValues).map(function (v, i) {
            if (fieldIndex === i) {
                return fieldValue;
            }
            return v;
        }) });
}
function updateStateItemValues(state, fieldValue, fieldIndex) {
    var res = __assign(__assign({}, state), { itemValues: __spreadArrays(state.itemValues).map(function (v, i) {
            if (fieldIndex === i) {
                return fieldValue;
            }
            return v;
        }) });
    return res;
}
function reducer(state, action) {
    switch (action.type) {
        case 'textValueChanged':
            return updateStateTextValues(state, action.fieldValue, action.fieldIndex);
        case 'dateValueChanged':
            return updateStateDateValues(state, action.fieldValue, action.fieldIndex);
        case 'itemValueChanged':
            return updateStateItemValues(state, action.fieldValue, action.fieldIndex);
        case 'resetFilters':
            return init(state.fieldLength);
        case 'acceptFilters':
            return __assign(__assign({}, state), { calloutOpen: false, commitedDateValues: state.dateValues, commitedTextValues: state.textValues, commitedItemValues: state.itemValues, isFiltered: action.isFiltered });
        case 'closeCallout':
            return __assign(__assign({}, state), { calloutOpen: false });
        case 'openCallout':
            return __assign(__assign({}, state), { calloutOpen: true, dateValues: state.commitedDateValues, itemValues: state.commitedItemValues, textValues: state.commitedTextValues });
        default:
            return __assign({}, state);
    }
}
exports.FilteredHeaderColumn = function (props) {
    var _a, _b;
    var filter = props.filter, column = props.column, forceResetFilter = props.forceResetFilter;
    var fieldNames = filter.fieldNames;
    var fields = fieldNames !== null && fieldNames !== void 0 ? fieldNames : [
        {
            fieldName: (_a = column.fieldName) !== null && _a !== void 0 ? _a : column.key,
            displayName: column.name,
        },
    ];
    var menuCaretRef = react_2.useRef(null);
    var _c = react_2.useReducer(reducer, fields.length, init), state = _c[0], dispatch = _c[1];
    var t = react_i18next_1.useTranslation('common').t;
    var resetFilter = function (notify) {
        dispatch({ type: 'resetFilters' });
        if (filter.onTextChange) {
            filter.onTextChange([]);
        }
        if (filter.onDropdownChange) {
            filter.onDropdownChange([]);
        }
        if (filter.onDateChange) {
            filter.onDateChange([]);
        }
        if (filter.onReset) {
            filter.onReset();
        }
        if (notify) {
            props.onfilterApply(props.column, undefined);
        }
    };
    react_2.useEffect(function () {
        if (forceResetFilter) {
            resetFilter(false);
        }
    }, [forceResetFilter]);
    var getFilterValue = function (fieldDef, i) {
        var filterValue = undefined;
        if (fieldDef.type === FilterType.Text) {
            filterValue = state.textValues[i];
        }
        else if (fieldDef.type === FilterType.Date) {
            filterValue = state.dateValues[i];
        }
        else if (state.itemValues[i] && state.itemValues[i].key !== 'all') {
            filterValue = state.itemValues[i].key;
        }
        return filterValue;
    };
    var acceptFilter = function () {
        if (filter.type === FilterType.Custom) {
            // fields.map((fn, i) => (
            //   getFilter(fn, i)
            // ));
            if (state.textValues.some(function (v) { return !!v; }) ||
                state.itemValues.some(function (v) { return !!v; }) ||
                state.dateValues.some(function (v) { return !!v; })) {
                if (filter.onTextChange) {
                    filter.onTextChange(state.textValues);
                }
                if (filter.onDropdownChange) {
                    filter.onDropdownChange(state.itemValues);
                }
                props.onfilterApply(props.column, fields.map(function (fieldDef, i) { return ({
                    fieldName: fieldDef.fieldName,
                    filterValue: getFilterValue(fieldDef, i),
                }); }));
            }
            else {
                props.onfilterApply(props.column, undefined);
            }
        }
        else {
            switch (filter.type) {
                case FilterType.Text:
                    if (state.textValues.some(function (v) { return !!v; })) {
                        if (filter.onTextChange) {
                            filter.onTextChange(state.textValues);
                        }
                        props.onfilterApply(props.column, fields.map(function (fieldDef, i) { return ({
                            fieldName: fieldDef.fieldName,
                            filterValue: state.textValues[i],
                        }); }));
                    }
                    else {
                        props.onfilterApply(props.column, undefined);
                    }
                    break;
                case FilterType.Date:
                    if (state.dateValues.some(function (v) { return !!v; })) {
                        if (filter.onDateChange) {
                            filter.onDateChange(state.dateValues);
                        }
                        props.onfilterApply(props.column, fields.map(function (fieldDef, i) { return ({
                            fieldName: fieldDef.fieldName,
                            filterValue: state.dateValues[i],
                        }); }));
                    }
                    else {
                        props.onfilterApply(props.column, undefined);
                    }
                    break;
                case FilterType.Enum:
                    if (state.itemValues.some(function (v) { return !!v; })) {
                        if (filter.onDropdownChange) {
                            filter.onDropdownChange(state.itemValues);
                        }
                        props.onfilterApply(props.column, fields.map(function (fieldDef, i) { return ({
                            fieldName: fieldDef.fieldName,
                            filterValue: state.itemValues[i] && state.itemValues[i].key !== 'all'
                                ? state.itemValues[i].key
                                : undefined,
                        }); }));
                    }
                    else {
                        props.onfilterApply(props.column, undefined);
                    }
                    break;
                default:
                    break;
            }
        }
        dispatch({
            type: 'acceptFilters',
            isFiltered: state.textValues.some(function (v) { return !!v; }) ||
                state.itemValues.some(function (v) { return !!v && v.key !== 'all'; }) ||
                state.dateValues.some(function (v) { return !!v; }),
        });
    };
    var getInput = function (fn, i) {
        var _a, _b, _c, _d, _e, _f;
        var type = filter.type === FilterType.Custom ? fn.type : filter.type;
        switch (type) {
            case FilterType.Label:
                return (react_2.default.createElement(react_2.default.Fragment, null,
                    react_2.default.createElement(forms_1.Label, { key: fn.fieldName, required: fn.required, className: fn.className }, fn.value)));
            case FilterType.Text:
                return (react_2.default.createElement(react_2.default.Fragment, null,
                    react_2.default.createElement(forms_1.TextField, { key: fn.fieldName, label: fn.displayName, placeholder: (_a = fn.placeholder) !== null && _a !== void 0 ? _a : filter.placeholder, inputMode: "search", value: state.textValues[i], disabled: fn.disabled, onKeyPress: function (e) {
                            if (e.key === 'Enter') {
                                acceptFilter();
                            }
                        }, onChange: function (_, value) {
                            if (value !== undefined) {
                                dispatch({
                                    type: 'textValueChanged',
                                    fieldValue: value,
                                    fieldIndex: i,
                                });
                            }
                        } })));
            case FilterType.Date:
                return (react_2.default.createElement(react_2.default.Fragment, null,
                    react_2.default.createElement(forms_1.DatePicker, { key: fn.fieldName, label: fn.displayName, placeholder: (_b = fn.placeholder) !== null && _b !== void 0 ? _b : filter.placeholder, isRequired: false, value: state.dateValues[i], disabled: fn.disabled, className: "search-box-first-name", onSelectDate: function (date) {
                            if (date !== undefined && date !== null) {
                                dispatch({
                                    type: 'dateValueChanged',
                                    fieldValue: date,
                                    fieldIndex: i,
                                });
                            }
                        } })));
            case FilterType.Enum:
                return (react_2.default.createElement(react_2.default.Fragment, null,
                    react_2.default.createElement(forms_1.Dropdown, { key: fn.fieldName, label: fn.displayName, placeholder: (_c = fn.placeholder) !== null && _c !== void 0 ? _c : filter.placeholder, selectedKey: fn.selectedKey, disabled: fn.disabled, defaultSelectedKey: ((_d = state.commitedItemValues[i]) === null || _d === void 0 ? void 0 : _d.key) || 'all', onChanged: function (item) {
                            if (fn.onDropdownChange)
                                fn.onDropdownChange(item);
                            dispatch({
                                type: 'itemValueChanged',
                                fieldValue: item,
                                fieldIndex: i,
                            });
                        }, options: (_f = (_e = fn.options) !== null && _e !== void 0 ? _e : filter.options) !== null && _f !== void 0 ? _f : [] })));
            default:
                return react_2.default.createElement(react_2.default.Fragment, null);
        }
    };
    var getFilterInput = function () {
        if (!filter) {
            return null;
        }
        if (filter.type === FilterType.Custom) {
            return react_2.default.createElement(react_2.default.Fragment, null, fields.map(function (fn, i) { return getInput(fn, i); }));
        }
        switch (filter.type) {
            case FilterType.Text:
                return react_2.default.createElement(react_2.default.Fragment, null, fields.map(function (fn, i) { return getInput(fn, i); }));
            case FilterType.Date:
                return react_2.default.createElement(react_2.default.Fragment, null, fields.map(function (fn, i) { return getInput(fn, i); }));
            case FilterType.Enum:
                return react_2.default.createElement(react_2.default.Fragment, null, fields.map(function (fn, i) { return getInput(fn, i); }));
            default:
                return react_2.default.createElement(react_2.default.Fragment, null);
        }
    };
    var clickSort = function (e) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore e being of that exact type is not required here.
        props.onColumnClick(e, props.column);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore e being of that exact type is not required here.
        if (column.onColumnClick) {
            column.onColumnClick(e, column);
        }
    };
    react_2.useEffect(function () {
        var _a;
        if (filter.selectedKey) {
            var selectedItem = (_a = filter.options) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.key === filter.selectedKey; });
            if (selectedItem)
                dispatch({
                    type: 'itemValueChanged',
                    fieldValue: selectedItem,
                    fieldIndex: 0,
                });
            acceptFilter();
        }
    }, [filter.selectedKey]);
    return (react_2.default.createElement("span", { "aria-hidden": true, className: clsx_1.default('table-custom-header-cell', state.isFiltered ? 'filter' : ''), onClick: clickSort },
        react_2.default.createElement("span", { ref: menuCaretRef },
            react_2.default.createElement(react_1.IconButton, { className: state.isFiltered ? 'active' : '', onClick: function (e) {
                    dispatch({ type: 'openCallout' });
                    e.stopPropagation();
                }, iconProps: { iconName: state.isFiltered ? 'FilterSolid' : 'Filter' } })),
        react_2.default.createElement("span", { className: "table-custom-header-cell-title" }, (_b = column.nameAsJsx) !== null && _b !== void 0 ? _b : column.name),
        column.isSorted && (react_2.default.createElement("span", null,
            react_2.default.createElement(react_1.IconButton, { iconProps: {
                    iconName: column.isSortedDescending ? 'SortDown' : 'SortUp',
                } }))),
        !column.isSorted && column.allowSorting && (react_2.default.createElement("span", null,
            react_2.default.createElement(react_1.IconButton, { iconProps: {
                    iconName: 'Sort',
                } }))),
        filter && state.calloutOpen ? (react_2.default.createElement(react_1.Callout, { className: "table-filter-callout", target: menuCaretRef.current, beakWidth: 12, onDismiss: function () { return dispatch({ type: 'closeCallout' }); } },
            getFilterInput(),
            react_2.default.createElement("div", { className: "table-filter-callout-buttons" },
                (filter === null || filter === void 0 ? void 0 : filter.useFilterButton) ? (react_2.default.createElement(react_1.PrimaryButton, { className: "customClearFilterButton", menuIconProps: { iconName: 'ClearFilter' }, text: t('clearFilters'), onClick: function () { return resetFilter(true); } })) : (react_2.default.createElement(react_1.IconButton, { onClick: function () { return resetFilter(true); }, iconProps: { iconName: 'ClearFilter' } })),
                (filter === null || filter === void 0 ? void 0 : filter.useFilterButton) ? (react_2.default.createElement(react_1.PrimaryButton, { className: "customApplyFilterButton", menuIconProps: { iconName: 'FilterSolid' }, text: t('apply'), onClick: function () { return acceptFilter(); } })) : (react_2.default.createElement(react_1.IconButton, { onClick: function () { return acceptFilter(); }, iconProps: { iconName: 'CheckMark' } }))))) : null));
};
//# sourceMappingURL=FilteredHeaderColumn.js.map